import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBookOf = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.53 2.5a.75.75 0 0 0-.957-.457L4.393 5.645a2.02 2.02 0 0 0-1.267 1.25c-.193.549-.153 1.151.04 1.696l.042.111 4.12 11.655c.192.542.537 1.036 1.033 1.342.514.317 1.14.397 1.772.175h.002l10.824-3.826a.75.75 0 0 0 .457-.957L17.295 5.43a.75.75 0 0 0-.957-.458L5.513 8.799c-.204.072-.356.041-.484-.037-.147-.09-.306-.275-.41-.567l-.04-.111c-.102-.29-.094-.53-.038-.692.05-.142.15-.261.353-.333l9.472-3.352.31.874a.75.75 0 0 0 1.414-.501zM8.742 19.856l-3.365-9.518q.314-.013.637-.125L16.13 6.637l3.622 10.247-10.117 3.575c-.209.073-.36.041-.486-.036-.145-.09-.303-.274-.407-.567m6.627-9.63a.75.75 0 0 0-.5-1.414l-7.11 2.515a.75.75 0 0 0 .5 1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBookOf;
